<template>
    <div class="list row backup-list">
        <div class="col-md-12">
            <h4>Backupovi</h4>
            <div v-if="loading" class="alert alert-info">Loading...</div>
            <div v-else>
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col">Naziv fajla</th>
                            <th scope="col">Datum</th>
                            <th scope="col">Veličina</th>
                            <th scope="col">Akcija</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(file, index) in backups" :key="index">
                            <td>{{ file.name }}</td>
                            <td>{{ formatDate(file.date) }}</td>
                            <td>{{ file.size }}</td>
                            <td>
                                <button class="btn btn-sm btn-primary me-2" @click="downloadBackup(file.name)">
                                    Download
                                </button>
                                <button class="btn btn-sm btn-danger" @click="deleteBackup(file)">
                                    Delete
                                </button>
                            </td>
                        </tr>
                        <tr v-if="backups.length === 0">
                            <td colspan="4" class="text-center">Nema backupa.</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import BackupService from "../../services/backup.service";
import utils from "../../utils/common";

export default {
    name: "BackupList",
    data() {
        return {
            backups: [],
            loading: false,
        };
    },
    methods: {
        getBackups() {
            this.loading = true;
            BackupService.getAll()
                .then(response => {
                    this.backups = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e);
                    this.loading = false;
                });
        },
        downloadBackup(filename) {
            BackupService.download(filename)
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch(e => {
                    console.log(e);
                    this.$store.commit("app/showAlert", {
                        type: "danger",
                        message: "Greška prilikom preuzimanja: " + e,
                    });
                });
        },
        deleteBackup(file) {
            utils.showDialog(
                file,
                "Da li ste sigurni da želite da obrišete ovaj backup?",
                "Brisanje backupa: " + file.name,
                () => {
                    BackupService.delete(file.name)
                        .then(() => {
                            this.getBackups();
                            this.$store.commit("app/hideModal");
                        })
                        .catch(e => {
                            console.log(e);
                            this.$store.commit("app/showAlert", {
                                type: "danger",
                                message: "Greška prilikom brisanja: " + e,
                            });
                        });
                }
            );
        },
        formatDate(dateString) {
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' };
            return new Date(dateString).toLocaleDateString('sr-RS', options);
        }
    },
    mounted() {
        this.getBackups();
    }
};
</script>

<style>
.backup-list {
    text-align: left;
    max-width: 900px;
    margin: auto;
}
</style>
